import React from "react";
import Modal from "react-bootstrap/Modal";
import { gql } from "@apollo/client";

import closeIcon from "../../../assets/close.svg";
import "./InviteBulkUsersModal.scss";
import { isValidEmail } from "../AddNewUserModal/AddNewUserModal";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";

export default class InviteBulkUsersModal extends React.Component {
  state = {
    managerEmail: "",
    userEmail: "",
    guestEmail: "",
    adminEmail: "",
    parsedManagerEmail: [],
    parsedUserEmail: [],
    parsedGuestEmail: [],
    parsedAdminEmail: [],
    allEmailList: [],
    isManagerRepeat: false,
    isUserRepeat: false,
    isGuestRepeat: false,
    isAdminRepeat: false,
  };

  typeMapping = {
    manager: "managerEmail",
    user: "userEmail",
    guest: "guestEmail",
    admin: "adminEmail",
  };

  parsedListTypeMapping = {
    manager: "parsedManagerEmail",
    user: "parsedUserEmail",
    guest: "parsedGuestEmail",
    admin: "parsedAdminEmail",
  };

  validateRepeat = (emailList, type) => {
    const email =
      emailList.length > 0
        ? emailList[emailList.length - 1].email
        : emailList[0];

    let {
      parsedManagerEmail,
      parsedUserEmail,
      parsedGuestEmail,
      parsedAdminEmail,
      isManagerRepeat,
      isUserRepeat,
      isGuestRepeat,
      isAdminRepeat,
    } = this.state;
    let allEmails = [];
    if (type === "managerEmail") {
      allEmails = [
        ...allEmails,
        ...parsedManagerEmail.slice(0, parsedManagerEmail.length - 1),
        ...parsedUserEmail,
        ...parsedGuestEmail,
        ...parsedAdminEmail
      ];
    }
    if (type === "userEmail") {
      allEmails = [
        ...allEmails,
        ...parsedManagerEmail,
        ...parsedUserEmail.slice(0, parsedUserEmail.length - 1),
        ...parsedGuestEmail,
        ...parsedAdminEmail
      ];
    }
    if (type === "guestEmail") {
      allEmails = [
        ...allEmails,
        ...parsedManagerEmail,
        ...parsedUserEmail,
        ...parsedGuestEmail.slice(0, parsedGuestEmail.length - 1),
        ...parsedAdminEmail
      ];
    }
    if (type === "adminEmail") {
      allEmails = [
        ...allEmails,
        ...parsedManagerEmail,
        ...parsedUserEmail,
        ...parsedGuestEmail,
        ...parsedAdminEmail.slice(0, parsedAdminEmail.length - 1),
      ];
    }

    let isValid = true;
    let onlyEmailList = [];
    allEmails.map((subEmail) => {
      onlyEmailList.push(subEmail.email);
      if (subEmail.email === email) {
        isValid = false;
      }
      return true;
    });

    if (!isValid) {
      if (type === "managerEmail") {
        isManagerRepeat = true;
      }
      if (type === "userEmail") {
        isUserRepeat = true;
      }
      if (type === "guestEmail") {
        isGuestRepeat = true;
      }
      if (type === "adminEmail") {
        isAdminRepeat = true;
      }
    } else {
      const uniqueAllEmails = [...new Set(onlyEmailList)];

      if (uniqueAllEmails.length === allEmails.length) {
        isManagerRepeat = false;
        isUserRepeat = false;
        isGuestRepeat = false;
        isAdminRepeat = false;
      }
    }

    return this.setState({ isManagerRepeat, isUserRepeat, isGuestRepeat, isAdminRepeat });
  };

  hasValidValues = () => {
    const {
      managerEmail,
      userEmail,
      guestEmail,
      adminEmail,
      parsedManagerEmail,
      parsedUserEmail,
      parsedGuestEmail,
      parsedAdminEmail,
      isManagerRepeat,
      isUserRepeat,
      isGuestRepeat,
      isAdminRepeat,
    } = this.state;
    let isValid = false;

    //Manager email validation
    if (managerEmail) {
      if (parsedManagerEmail.length > 0) {
        isValid =
          parsedManagerEmail.filter((emailObj) => emailObj.isValid).length ===
          parsedManagerEmail.length;

        if (!isValid) {
          return isValid;
        }
      } else {
        isValid = false;
      }
    }

    // user email validation
    if (userEmail) {
      if (parsedUserEmail.length > 0) {
        isValid =
          parsedUserEmail.filter((emailObj) => emailObj.isValid).length ===
          parsedUserEmail.length;

        if (!isValid) {
          return isValid;
        }
      } else {
        isValid = false;
      }
    }

    // guest email validation
    if (guestEmail) {
      if (parsedGuestEmail.length > 0) {
        isValid =
          parsedGuestEmail.filter((emailObj) => emailObj.isValid).length ===
          parsedGuestEmail.length;

        if (!isValid) {
          return isValid;
        }
      } else {
        isValid = false;
      }
    }

    // admin email validation
    if (adminEmail) {
      if (parsedAdminEmail.length > 0) {
        isValid =
          parsedAdminEmail.filter((emailObj) => emailObj.isValid).length ===
          parsedAdminEmail.length;

        if (!isValid) {
          return isValid;
        }
      } else {
        isValid = false;
      }
    }

    if (isManagerRepeat || isUserRepeat || isGuestRepeat || isAdminRepeat) {
      isValid = false;
    }

    return isValid;
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        managerEmail: "",
        userEmail: "",
        guestEmail: "",
        adminEmail: "",
        parsedManagerEmail: [],
        parsedUserEmail: [],
        parsedGuestEmail: [],
        parsedAdminEmail: [],
        isManagerRepeat: false,
        isUserRepeat: false,
        isGuestRepeat: false,
        isAdminRepeat: false,
      });
    }
  }

  removeEmailFromList = (index, type) => {
    const targetList = this.parsedListTypeMapping[type];
    let newList = [...this.state[targetList]];
    newList.splice(index, 1);

    // Form new email string
    let newEmailList = newList.map((emailObj) => emailObj.email);
    let newEmailString = this.state[this.typeMapping[type]].includes(";")
      ? newEmailList.join(";")
      : newEmailList.join(",");

    this.setState({
      [targetList]: newList,
      [this.typeMapping[type]]: newEmailString,
    });
  };

  getValidEmails = (emailList, type) => {
    let isEmailValid;
    emailList.map((emailObj) => {
      isEmailValid = !emailObj.isValid;
      return true;
    });

    return isEmailValid;
  };

  getEmailList = (emailList, type) => {
    return emailList.map((emailObj, index) => (
      <div
        key={index}
        className={`email-frame${!emailObj.isValid ? " invalid" : ""}`}
      >
        <p>{emailObj.email}</p>
        <img
          className="close"
          width="12"
          height="12"
          src={closeIcon}
          alt="close"
          onClick={() => this.removeEmailFromList(index, type)}
        />
      </div>
    ));
  };

  handleEmailInputChange = (e, type) => {
    const targetEmail = this.typeMapping[type];
    const newEmail = e.target.value;
    this.setState({ [targetEmail]: newEmail });

    let emailList = newEmail.includes(";")
      ? newEmail.trim().split(";")
      : newEmail.trim().split(",");
    if (emailList.length === 1) {
      if (isValidEmail(emailList)) {
        this.setState(
          {
            [this.parsedListTypeMapping[type]]: [
              { email: emailList[0], isValid: true },
            ],
          },
          () =>
            this.validateRepeat(
              [{ email: emailList[0], isValid: true }],
              targetEmail
            )
        );
      } else {
        this.setState(
          {
            [this.parsedListTypeMapping[type]]: [],
          },
          () => this.validateRepeat([], targetEmail)
        );
      }
    } else {
      let parsedEmailList = [];
      emailList.forEach((email) => {
        email = email.trim();
        if (email.length > 0)
          parsedEmailList.push({ email: email, isValid: isValidEmail(email) });
      });
      if (
        parsedEmailList.length > 0 &&
        parsedEmailList[parsedEmailList.length - 1].email.length === 0
      ) {
        parsedEmailList.pop();
      }
      this.setState(
        { [this.parsedListTypeMapping[type]]: parsedEmailList },
        () => this.validateRepeat(parsedEmailList, targetEmail)
      );
    }
  };

  sendValidUsersList = () => {
    let validUsersList = {
      manager: this.state.parsedManagerEmail
        .filter((emailObj) => emailObj.isValid)
        .map((emailObj) => emailObj.email),
      user: this.state.parsedUserEmail
        .filter((emailObj) => emailObj.isValid)
        .map((emailObj) => emailObj.email),
      guest: this.state.parsedGuestEmail
        .filter((emailObj) => emailObj.isValid)
        .map((emailObj) => emailObj.email),
      admin: this.state.parsedAdminEmail
        .filter((emailObj) => emailObj.isValid)
        .map((emailObj) => emailObj.email),
    };
    // this.props.onInviteBulkUsers(validUsersList);

    // e.preventDefault();

    // -------------- DATA: ----------------
    // "[
    //    {
    //         "role_id": 2,
    //         "emails": [
    //           "amin.abhi297@gmail.com"
    //         ]
    //    }
    // ]"

    let json_data = [];

    if (validUsersList.manager.length > 0) {
      json_data.push({
        role_id: 3,
        emails: validUsersList.manager,
      });
    }

    if (validUsersList.user.length > 0) {
      json_data.push({
        role_id: 4,
        emails: validUsersList.user,
      });
    }

    if (validUsersList.guest.length > 0) {
      json_data.push({
        role_id: 5,
        emails: validUsersList.guest,
      });
    }

    if (validUsersList.admin.length > 0) {
      json_data.push({
        role_id: 2,
        emails: validUsersList.admin,
      });
    }

    json_data = JSON.stringify(json_data);
    const variables = {
      data: json_data,
    };

    apolloClient
      .mutate({
        variables: variables,
        mutation: gql`
          mutation SendMultipleUserInvitation($data: String!) {
            sendMultipleUserInvitation(data: $data) {
              tokens
              success
            }
          }
        `,
      })
      .then((result) => {
        if (result.data.sendMultipleUserInvitation.tokens) {
          this.props.handleClose();

          // notify that user invited successfully
          const title = "Success";
          const detail = "Invitation sent successfully";
          const type = "success";

          notify(title, detail, type);
        }
      })
      .catch((e) => {
        //notify for an error
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  render() {
    return (
      <Modal
        className="bulk-users-modal"
        size="xl"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="bulk-users-modal-content">
          <div className="header">
            <h3 className="title is-size-h4 bold">Invite users in bulk</h3>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={this.props.handleClose}
            />
          </div>

          <div className="body row">
            <div className="col manager-container py-5">
              <h3>Add for Manager Role(s)</h3>
              <div className="form-group">
                <label>
                  <strong>Enter Email Id</strong>
                </label>
                <input
                  type="email"
                  value={this.state.managerEmail}
                  onChange={(e) => this.handleEmailInputChange(e, "manager")}
                  className={`form-control manager-email ${
                    this.state.managerEmail &&
                    this.state.parsedManagerEmail.length === 0
                      ? "error-input"
                      : this.getValidEmails(this.state.parsedManagerEmail)
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="john.doe@email.com,will.smith@email.com"
                />
                {this.state.managerEmail &&
                this.state.parsedManagerEmail.length === 0 ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.getValidEmails(this.state.parsedManagerEmail) ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.state.isManagerRepeat ? (
                  <label className="error">
                    Please remove duplicate emails addresses.
                  </label>
                ) : null}
              </div>

              {this.state.parsedManagerEmail.length > 0 ? (
                <div className="email-list">
                  <label>Email Address</label>
                  <div className="parsed-emails">
                    {this.getEmailList(
                      this.state.parsedManagerEmail,
                      "manager"
                    )}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="col user-container py-5">
              <h3>Add for Basic User Role(s) &nbsp;</h3>
              <div className="form-group">
                <label>
                  <strong>Enter Email Id</strong>
                </label>
                <input
                  type="email"
                  value={this.state.userEmail}
                  onChange={(e) => this.handleEmailInputChange(e, "user")}
                  className={`form-control user-email ${
                    this.state.userEmail &&
                    this.state.parsedUserEmail.length === 0
                      ? "error-input"
                      : this.getValidEmails(
                          this.state.parsedUserEmail,
                          "manager"
                        ) && this.state.parsedUserEmail.length > 0
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="john.doe@email.com,will.smith@email.com"
                />
                {this.state.userEmail &&
                this.state.parsedUserEmail.length === 0 ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.getValidEmails(this.state.parsedUserEmail, "user") &&
                  this.state.parsedUserEmail.length > 0 ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.state.isUserRepeat ? (
                  <label className="error">
                    Please remove duplicate emails addresses.
                  </label>
                ) : null}
              </div>

              {this.state.parsedUserEmail.length > 0 ? (
                <div className="email-list">
                  <label>Email Address</label>
                  <div className="parsed-emails">
                    {this.getEmailList(this.state.parsedUserEmail, "user")}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="col guest-container py-5">
              <h3>Add for Guest Role(s)</h3>
              <div className="form-group">
                <label>
                  <strong>Enter Email Id</strong>
                </label>
                <input
                  type="email"
                  value={this.state.guestEmail}
                  onChange={(e) => this.handleEmailInputChange(e, "guest")}
                  className={`form-control guest-email ${
                    this.state.guestEmail &&
                    this.state.parsedGuestEmail.length === 0
                      ? "error-input"
                      : this.getValidEmails(this.state.parsedGuestEmail) &&
                        this.state.parsedGuestEmail.length > 0
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="john.doe@email.com,will.smith@email.com"
                />
                {this.state.guestEmail &&
                this.state.parsedGuestEmail.length === 0 ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.getValidEmails(this.state.parsedGuestEmail, "guest") &&
                  this.state.parsedGuestEmail.length > 0 ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : this.state.isGuestRepeat ? (
                  <label className="error">
                    Please remove duplicate emails addresses.
                  </label>
                ) : null}
              </div>

              {this.state.parsedGuestEmail.length > 0 ? (
                <div className="email-list">
                  <label>Email Address</label>
                  <div className="parsed-emails">
                    {this.getEmailList(this.state.parsedGuestEmail, "guest")}
                  </div>
                </div>
              ) : null}
            </div>
            {
              parseInt(this.props.currentUserId) === 1 ? (
                <div className="col admin-container py-5">
                  <h3>Add for Admin Role(s)</h3>
                  <div className="form-group">
                    <label>
                      <strong>Enter Email Id</strong>
                    </label>
                    <input
                      type="email"
                      value={this.state.adminEmail}
                      onChange={(e) => this.handleEmailInputChange(e, "admin")}
                      className={`form-control admin-email ${
                        this.state.adminEmail &&
                        this.state.parsedAdminEmail.length === 0
                          ? "error-input"
                          : this.getValidEmails(this.state.parsedAdminEmail)
                          ? "error-input"
                          : ""
                      }`}
                      placeholder="john.doe@email.com,will.smith@email.com"
                    />
                    {this.state.adminEmail &&
                    this.state.parsedAdminEmail.length === 0 ? (
                      <label className="error">
                        Please enter a valid email address eg: xyz@xyz.com
                      </label>
                    ) : this.getValidEmails(this.state.parsedAdminEmail) ? (
                      <label className="error">
                        Please enter a valid email address eg: xyz@xyz.com
                      </label>
                    ) : this.state.isAdminRepeat ? (
                      <label className="error">
                        Please remove duplicate emails addresses.
                      </label>
                    ) : null}
                  </div>

                  {this.state.parsedAdminEmail.length > 0 ? (
                    <div className="email-list">
                      <label>Email Address</label>
                      <div className="parsed-emails">
                        {this.getEmailList(
                          this.state.parsedAdminEmail,
                          "admin"
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null
            }
            
          </div>

          <div className="footer">
            <button
              className="btn-primary create-button"
              disabled={!this.hasValidValues()}
              onClick={this.sendValidUsersList}
            >
              Invite
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
